import { useEffect, useRef } from "react";

import { useStore } from "../lib/store";
import { cx } from "./ui";

function lineTone(line: string): string {
  const raw = line.toUpperCase();
  if (line.includes("📱") || raw.includes("SCREENING")) return "text-mute";
  if (line.includes("👤") || raw.includes("HUMAN")) return "text-ok";
  if (raw.includes("DEAD_AIR") || raw.includes("DEAD AIR") || raw.includes("UNCERTAIN")) {
    return "text-mute";
  }
  if (
    line.includes("🤖") ||
    raw.includes(" VM") ||
    raw.endsWith("VM") ||
    raw.includes("VOICEMAIL") ||
    raw.includes("IVR_MENU") ||
    raw.includes("HANGUP") ||
    raw.includes("FAIL") ||
    raw.includes("ERROR")
  ) {
    return raw.includes("HANGUP") || raw.includes("FAIL") || raw.includes("ERROR")
      ? "text-fail"
      : "text-warn";
  }
  if (raw.includes("OK") || raw.includes("ACCEPT") || raw.includes("MATCH")) return "text-ok";
  return "text-ink/80";
}

/**
 * Left operator strip. Human copy only.
 */
export function EventLog() {
  const lines = useStore().state.operatorLog;
  const scroller = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = scroller.current;
    if (node) node.scrollTop = node.scrollHeight;
  }, [lines]);
  return (
    <section className="flex min-h-0 flex-1 flex-col border-t border-teal/10 md:border-r">
      <header className="border-b border-teal/10 px-4 py-2 font-mono text-[11px] tracking-[0.18em] text-teal">
        event.log
      </header>
      <div
        ref={scroller}
        className="scroll-thin min-h-0 flex-1 overflow-auto px-4 py-3 font-mono text-[12px] leading-6"
      >
        {lines.length === 0 ? (
          <div className="text-mute">waiting for a call.</div>
        ) : (
          lines.map((line) => (
            <div key={line.id} className={cx(lineTone(line.line))}>
              <span className="mr-3 text-teal/50">{line.ts.slice(11, 19)}</span>
              {line.line}
            </div>
          ))
        )}
      </div>
    </section>
  );
}
